import './header.scss';

function Header() {
   return (
      <header className = "header">
         <div className = "header__wrapper">
            <img  className="pic_MONITOR" src= "/img/MONITOR.png" alt= "MONITOR AUDIO"></img>
            <p className="pic-Silver">Silver 6G</p>
            <img className="pic_logo" src= "/img/logo1.png" alt= ""></img>
         </div>
      </header>
   )
}
export default Header;